/** @format */

const API = {
  getNameSpace: '/cm/metrics/DescribeNameSpaces', // 获取命名空间
  getDescribeMetrics: '/cm/metrics/DescribeMetrics', // 获取命名空间下指标
  GetChartData: '/cm/datas/DescribeHistoryData', // 查询监控数据
  getMetricsUnique: '/cm/metrics/DescribeMetricsUnique', // 获取指标
  getDescribeDimensions: '/cm/metrics/DescribeDimensions', // 获取维度
  getDescribeRegions: '/cm/regions/DescribeRegions', //获取自定义监控region
  removeNamespaces: '/cm/metrics/RemoveNamespaces', //删除命名空间
  removeMetrics: '/cm/metrics/RemoveMetrics' //删除指标
}
export default API
